import {
	BlurModal,
	ModalHeader,
	UserAdd,
} from '@aleph/shared-components';
import RedditUsersMutator from 'wb-reddit/app/routes/users/mutator/usersMutator';
import useRedditUserMutationStorage from 'wb-reddit/app/routes/users/mutator/useRedditUserMutationStorage';
import RedditUsersEditMutator from 'wb-reddit/app/routes/users/mutator/usersEditMutator';
import { HandleUpdateUserRow } from 'wb-reddit/app/routes/users/container';
import { SetShowConfirmActionDialog } from 'wb-reddit/app/routes/hooks/useConfirmAction';
import { useTranslation } from 'react-i18next';
import useSaveBeforeExitDialog from 'wb-reddit/app/routes/hooks/useSaveBeforeExitDialog';

interface IProps {
	updateRow: HandleUpdateUserRow
}

export interface MutatorProps {
	updateRow: HandleUpdateUserRow
	setShouldShowSaveBeforeExit: SetShowConfirmActionDialog
	beforeClose?: () => void
}

const RedditUsersMutatorContainer = ({ updateRow }: IProps) => {
	const { mutationUser, setMutationUser } = useRedditUserMutationStorage();
	const { t } = useTranslation();

	const isUpdate = !!mutationUser?.userId;

	const {
		beforeClose,
		dialog: saveBeforeExitModal,
		setShouldPromptOnClose: setShouldShowSaveBeforeExit,
	} = useSaveBeforeExitDialog({
		onConfirm: () => setMutationUser(undefined),
	});

	return (
		<BlurModal
			header={
				<ModalHeader
					icon={
						<UserAdd
							width={24}
							height={24}
						/>
					}
					title={isUpdate ? `${mutationUser.userName} ${mutationUser.userSurname || ''}` : t('sc: auth.create_new_user', 'Create new user')}
					onClose={beforeClose}
				/>
			}
			onClose={beforeClose}
			blur={isUpdate}
		>
			{isUpdate
				? (
					<RedditUsersEditMutator
						updateRow={updateRow}
						setShouldShowSaveBeforeExit={setShouldShowSaveBeforeExit}
					/>
				)
				: (
					<RedditUsersMutator
						setShouldShowSaveBeforeExit={setShouldShowSaveBeforeExit}
						updateRow={updateRow}
						beforeClose={beforeClose}
					/>)

			}

			{saveBeforeExitModal}
		</BlurModal>
	);
};

export default RedditUsersMutatorContainer;
